import {SVG} from '../../../../../../constants/assetLists';

type Props = {
  onAdd: () => void;
};

function QuestionAddButton({onAdd}: Props) {
  return (
    <div className="relative">
      <button
        type="button"
        onClick={onAdd}
        className="w-[40px] h-[40px] rounded-full bg-white border-2 border-deepAqua flex items-center justify-center hover:bg-softAquaLight transition-colors shadow-md">
        <img
          src={SVG.addIcon}
          alt="add"
          className="w-[16px] h-[16px] object-contain"
        />
      </button>
    </div>
  );
}

export default QuestionAddButton;
